import React from 'react'

import ErrorToast from '../../components/molecules/ErrorToast'

import { getSubscriptions } from '../../lib/api'

type SubscriptionContextType = {
  subscriptions: APIPaymentSubscription[]
  loaded: boolean
  error: any
}

const SubscriptionContext = React.createContext<SubscriptionContextType>(null)

const SubscriptionProvider = ({ children }) => {
  const [subscriptions, setSubscriptions] = React.useState([])
  const [loaded, setLoaded] = React.useState(false)
  const [error, setError] = React.useState(null)

  // Load subscriptions
  React.useEffect(() => {
    if (loaded) {
      return
    }

    getSubscriptions()
      .then(subscriptions => {
        setSubscriptions(subscriptions ?? [])
        setLoaded(true)
      })
      .catch(err => setError({ err, auto: true }))
  }, [loaded])

  return (
    <SubscriptionContext.Provider value={{ subscriptions, loaded, error }}>
      {children}

      <ErrorToast error={error} />
    </SubscriptionContext.Provider>
  )
}

export default SubscriptionProvider

export const useSubscription = () => React.useContext(SubscriptionContext)
